<div class="data-filter">
    <label [i18n]="[{target: 'innerHTML', key: labelKey}]"></label>
    <div class="data-filter-checkbox">
        <div class="checkbox" *ngFor="let o of options">
            <label>
                <input type="checkbox" [value]="o.value" [name]="name" (change)="change()" [(ngModel)]="o.checked">
                <i class="fa checkbox-icon"></i>
                <span [i18n]="[{target: 'innerHTML', key: o.labelKey }]"></span>
            </label>
        </div>
    </div>
</div>
